/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FILTER_TYPES, FilterType} from "../../../../data/finders.model";
import {ListCheckboxesFilter} from "./ListCheckboxesFilter";
import LinkedProductFilter from "./LinkedProductFilter";
import {TagType} from "../../../../data/aem.model";
import {connect} from "react-redux";
import {getTagMap, makeTagsMapper} from "../../../../selectors/tags";
import {getSearch, getSelectedTags, getSidepanel, getSidepanelIndex, hasSidepanel} from "../../../../selectors/finder";
import {setSearch, toggleTag} from "../../../../actions/finder";
import {SidepanelCheckboxesFilter} from "./SidepanelCheckboxesFilter";
import ButtonFilter from "./ButtonFilter";
import {BasicListFilter} from "./BasicListFilter";

class _Filter extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(FilterType), PropTypes.any]),
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        expandedSidePanel: PropTypes.bool,
        availableItems: PropTypes.array,
        showSearchItemAsFilter: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            containerOpen: 0
        };

        this.toggleTag = this.toggleTag.bind(this);
    }

    toggleTag = (tagId) => this.props.toggleTag({filterIndex: this.props.filter.index, tag: tagId});

    renderDefaultCheckboxes() {
        const {filter, selected, expandedSidePanel, sidepanel, availableTags} = this.props;

        let tags = [].concat(...filter.tags.map(tag => tag && tag?.children));

        if (filter.skipParentLevel) {
            tags = [].concat(...tags.map(tag => tag && tag?.children))
        }

        return <ListCheckboxesFilter filter={filter}
                                     selected={selected}
                                     tags={tags}
                                     availableTags={availableTags}
                                     sidepanel={sidepanel}
                                     expanded={expandedSidePanel}
                                     toggleTag={this.toggleTag}/>
    }

    renderExclusiveCheckboxes() {
        const {filter, selected, expandedSidePanel, sidepanel, availableTags, tags} = this.props;

        let title = filter.title;

        if (!title && filter.tags.length > 0 && filter.tags[0].id && tags) {
            let parentTagPath = filter.tags[0].id.substr(0, filter.tags[0].id.lastIndexOf("/"));
            let parentTag = Object.values(tags).find(tag => tag.id === parentTagPath);

            if (parentTag != null) {
                title = parentTag.title;
            }
        }

        return <ListCheckboxesFilter filter={{...filter, title}}
                                     selected={selected}
                                     availableTags={availableTags}
                                     sidepanel={sidepanel}
                                     expanded={expandedSidePanel}
                                     toggleTag={this.toggleTag}/>
    }

    render() {
        const {filter} = this.props;

        if (!filter) {
            return null;
        }

        if (filter.type === FILTER_TYPES.DEFAULT_CHECKBOXES_FILTER) {
            return this.renderDefaultCheckboxes();
        }

        if (filter.type === FILTER_TYPES.EXCLUSIVE_CHECKBOXES_FILTER) {
            return this.renderExclusiveCheckboxes();
        }

        if (filter.type === FILTER_TYPES.SIDEPANEL_CHECKBOXES_FILTER) {
            return <SidepanelCheckboxesFilter filter={filter}
                                              selected={this.props.selected}
                                              toggleTag={this.toggleTag}
                                              availableTags={this.props.availableTags}
                                              expanded={this.props.expandedSidePanel}/>
        }

        if (filter.type === FILTER_TYPES.BUTTON_FILTER) {
            return <ButtonFilter filter={filter}
                                 availableTags={this.props.availableTags}
                                 selected={this.props.selected}
                                 toggleTag={this.toggleTag}/>
        }

        if (filter.type === FILTER_TYPES.PRODUCT_DROPDOWN) {
            return <LinkedProductFilter availableItems={this.props.availableItems} filter={filter}/>;
        }

        if (filter.type === FILTER_TYPES.BASIC_LIST_FILTER) {
            return <BasicListFilter filter={filter} selected={this.props.selected} toggleTag={this.toggleTag}
                                    showSearchItemAsFilter={this.props.showSearchItemAsFilter}
                                    searchTerm={this.props.searchTerm} setSearch={this.props.setSearch}/>
        }

        return null;
    }

}

const mapStateToProps = () => {
    const selectedTagsSelector = makeTagsMapper((state, ownProps) => getSelectedTags(state, ownProps.filter.index));

    return (state, ownProps) => ({
        tags: getTagMap(state),
        selected: selectedTagsSelector(state, ownProps),
        expandedSidePanel: !!(hasSidepanel(state) && getSidepanelIndex(state) === ownProps.filter.index),
        sidepanel: getSidepanel(state),
        searchTerm: getSearch(state)
    });
};

const mapActionsToProps = {
    toggleTag,
    setSearch
};

export const Filter = connect(mapStateToProps, mapActionsToProps)(_Filter);
